module.exports = __webpack_public_path__ + "img/fondo-verde.793f9dd2.jpg";